const classicLight = {
  id: 'classicLight',
  displayName: 'Classic Light',
  enabled: true,
  graph: {
    writeSample: '#74B9FF', writeTrend: '#D1B3FF', writeMax: '#2ECC71',
    writeMin: '#FF7675', writeLatency: '#00CEC9',
    readSample: '#A89D8B', readTrend: '#A87323', readMax: '#03771C',
    readMin: '#690505', readLatency: '#FF00F2',
  },
  canvas: {
    chartBg: '#FFFFFF', gridColor: '#D3D3D3', textColor: '#4A4A4A',
  },
};
export default classicLight;
